// Import React Hooks
import { useState, useEffect, useCallback } from "react";

// Import React Icons
import { FiChevronLeft, FiChevronRight } from "react-icons/fi";
import { FaBoxesStacked } from "react-icons/fa6";

// Import Images
import cap1 from "../assets/images/training/cap-1.jpg";
import cap2 from "../assets/images/training/cap-2.jpg";
import cap3 from "../assets/images/training/cap-3.jpg";
import cap4 from "../assets/images/training/cap-4.jpg";
import cap5 from "../assets/images/training/cap-5.jpg";
import cap6 from "../assets/images/training/cap-6.jpg";
import cap7 from "../assets/images/training/cap-7.jpg";

// Training Component
const Services = () => {
  const [currentSlide, setCurrentSlide] = useState(0);

  const slides = [
    {
      id: 1,
      image: cap1,
      alt: "Servicios"
    },
    {
      id: 2,
      image: cap2,
      alt: "Servicios"
    },
    {
      id: 3,
      image: cap3,
      alt: "Servicios"
    },
    {
      id: 4,
      image: cap4,
      alt: "Servicios"
    },
    {
      id: 5,
      image: cap5,
      alt: "Servicios"
    },
    {
      id: 6,
      image: cap6,
      alt: "Servicios"
    },
    {
      id: 7,
      image: cap7,
      alt: "Servicios"
    }
  ];

  const nextSlide = useCallback(() => {
    setCurrentSlide((prev) => (prev === slides.length - 1 ? 0 : prev + 1));
  }, [slides.length]);

  const prevSlide = () => {
    setCurrentSlide((prev) => (prev === 0 ? slides.length - 1 : prev - 1));
  };

  useEffect(() => {
    const interval = setInterval(nextSlide, 5000);
    return () => clearInterval(interval);
  }, [nextSlide]);

  return (
    <div className="flex flex-col md:flex-row min-h-screen capacitaciones">
        {/* Text Content Section */}
      <div className="w-full md:w-1/2 p-8 md:p-16 flex flex-col justify-center capacitaciones-container">
         <h2 className='text-gray-800'>Servicios <FaBoxesStacked fontSize='large' className='capacitaciones-icon'/></h2>
        <span></span>
        <br />
        <p className='text-gray-800'>
          <strong>
            Nuestro compromiso con el servicio nos ha llevado a un crecimiento significativo:
          </strong>
        </p>   

        <p className='text-gray-800'>
          <strong>Asistencia Personalizada:</strong> Contamos con un equipo de <strong>25 colaboradores</strong> para asistirte
          en tus proyectos con el apoyo técnico de nuestro Arquitecto Mario Castillo con más de
          25 años de experiencia en construcción.
        </p>     

        <p className='text-gray-800'>
          <strong>Entrega Inmediata:</strong> Disponemos de <strong>dos amplios locales de 1000 m² cada uno </strong>
          ubicados sobre importantes arterias nacionales, la Ruta 8 y la Ruta 101, asegurando
          una distribución ágil.
        </p>  

        <p className='text-gray-800'>
          <strong>Parque Logístico:</strong> Para garantizar el stock y la capacidad de atender proyectos de
          cualquier escala, desarrollamos un <strong>parque logístico de 3500 m²</strong>.
        </p>      
      </div>

      {/* Carousel Section */}
      <div className="relative w-full md:w-1/2 h-[50vh] md:h-screen">
        {slides.map((slide, index) => (
          <div
            key={slide.id}
            className={`absolute inset-0 transition-opacity duration-500 ease-in-out ${
              index === currentSlide ? "opacity-100" : "opacity-0"
            }`}
          >
            <img
              src={slide.image}
              alt={slide.alt}
              className="w-full h-full object-cover transition duration-500"
              loading="lazy"
            />
          </div>
        ))}

        {/* Navigation Arrows */}
        <button
          onClick={prevSlide}
          className="absolute left-4 top-1/2 transform -translate-y-1/2 bg-white/80 p-2 rounded-full hover:bg-white transition-colors duration-200"
          aria-label="Previous slide"
        >
          <FiChevronLeft className="w-6 h-6" />
        </button>
        <button
          onClick={nextSlide}
          className="absolute right-4 top-1/2 transform -translate-y-1/2 bg-white/80 p-2 rounded-full hover:bg-white transition-colors duration-200"
          aria-label="Next slide"
        >
          <FiChevronRight className="w-6 h-6" />
        </button>

        {/* Indicator Dots */}
        <div className="absolute bottom-4 left-1/2 transform -translate-x-1/2 flex space-x-2">
          {slides.map((_, index) => (
            <button
              key={index}
              onClick={() => setCurrentSlide(index)}
              className={`w-3 h-3 rounded-full transition-colors duration-200 ${
                index === currentSlide ? "bg-white" : "bg-white/50"
              }`}
              aria-label={`Go to slide ${index + 1}`}
            />
          ))}
        </div>
      </div>
    </div>
  );
};

// Export Training Component
export default Services;